import { computed } from 'vue';

import { useResInputStore } from '@/features/Sparten/res/useInputStore';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';

export const hasNoMultipleVehicles: ConditionalRequestDefinition = {
  if: computed(() => !useResInputStore().leistungsumfang.hasMehrereFahrzeuge),
  drop: ['leistungsumfang.anzahlFahrzeuge'],
};

export const hasNoRental: ConditionalRequestDefinition = {
  if: computed(() => !useResInputStore().leistungsumfang.vermietung),
  drop: [
    'leistungsumfang.vermietungObjekteAnzahl',
    'leistungsumfang.bruttojahresmieteBetrag0',
    'leistungsumfang.bruttojahresmieteBetrag1',
    'leistungsumfang.bruttojahresmieteBetrag2',
  ],
};

export const hasOneRental: ConditionalRequestDefinition = {
  if: computed(
    () =>
      useResInputStore().leistungsumfang.vermietung &&
      useResInputStore().leistungsumfang.vermietungObjekteAnzahl?.length === 1,
  ),
  drop: [
    'leistungsumfang.bruttojahresmieteBetrag1',
    'leistungsumfang.bruttojahresmieteBetrag2',
  ],
};

export const hasTwoRental: ConditionalRequestDefinition = {
  if: computed(
    () =>
      useResInputStore().leistungsumfang.vermietung &&
      useResInputStore().leistungsumfang.vermietungObjekteAnzahl?.length === 2,
  ),
  drop: ['leistungsumfang.bruttojahresmieteBetrag2'],
};

export const hasNoPrivatProtection: ConditionalRequestDefinition = {
  if: computed(() => !useResInputStore().leistungsumfang.privat),
  drop: ['leistungsumfang.beruf'],
};

export const hasNoTrafficProtection: ConditionalRequestDefinition = {
  if: computed(() => !useResInputStore().leistungsumfang.verkehr),
  drop: [
    'leistungsumfang.hasMehrereFahrzeuge',
    'leistungsumfang.anzahlFahrzeuge',
  ],
};

export const hasJustOneVehicle: ConditionalRequestDefinition = {
  if: computed(() => !useResInputStore().leistungsumfang.hasMehrereFahrzeuge),
  drop: ['leistungsumfang.anzahlFahrzeuge'],
};

export const resInputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  hasNoMultipleVehicles,
  hasNoRental,
  hasOneRental,
  hasTwoRental,
  hasNoPrivatProtection,
  hasNoTrafficProtection,
  hasJustOneVehicle,
];
